module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "book",
    attrs: {
      "title": "Le French Oven"
    }
  }, [_c('div', {
    staticClass: "frontmatter"
  }, [_c('div', {
    staticClass: "recto"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "index"
    }
  }), _vm._v("Le"), _c('br'), _c('span', {
    staticClass: "french"
  }, [_vm._v("French")]), _c('br'), _vm._v("Oven")]), _vm._v(" "), _c('h3', {
    staticClass: "author"
  }, [_vm._v("Hillary Davis ")]), _vm._v(" "), _c('h4', [_vm._v("Photographs by Steven Rothfeld")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Gibbs Smith Logo",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "verso"
  }, [_c('p', {
    staticClass: "versotitle"
  }, [_vm._v("Le French Oven")]), _vm._v(" "), _c('p', [_vm._v("Digital Edition 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Text © 2015 Hillary Davis")]), _vm._v(" "), _c('p', [_vm._v("Photographs © 2015 Steven Rothfeld")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced by any means whatsoever\n            without written permission from the publisher, except brief portions quoted for purpose\n            of review.")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("Gibbs Smith")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("P.O. Box 667")]), _vm._v(" "), _c('p', [_vm._v("Layton, Utah 84041")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("Orders: 1.800.835.4993")]), _vm._v(" "), _c('p', [_vm._v("www.gibbs-smith.com")]), _vm._v(" "), _c('p', [_vm._v("ISBN: 978-1-4236-4054-7")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61faee50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 60
// module chunks = 0